import styles from "../../pages/CodesList.module.css";
import React from "react";

interface StatusChangeModalProps {
  show: boolean;
  statusModalCode: { code: string; used: boolean } | null;
  onCancel: () => void;
  onConfirm: () => void;
  isBulk?: boolean;
}

const StatusChangeModal: React.FC<StatusChangeModalProps> = ({ show, statusModalCode, onCancel, onConfirm, isBulk = false }) => {
  if (!show) return null;
  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        <h3 className={styles.modalTitle}>
          {isBulk
            ? "האם לשנות את הסטטוס של כל המספרים הנבחרים?"
            : statusModalCode && (
                <>האם לשנות את הסטטוס של המספר {statusModalCode.code} ל-{statusModalCode.used ? "פנוי" : "בשימוש"}?</>
              )}
        </h3>
        <div className={styles.modalActions}>
          <button onClick={onCancel} className={styles.cancelButton}>
            ביטול
          </button>
          <button
            onClick={onConfirm}
            className={statusModalCode && statusModalCode.used ? styles.updateButton : styles.deleteButton}
            style={statusModalCode && statusModalCode.used ? { backgroundColor: "#43a047" } : {}}
          >
            שנה סטטוס
          </button>
        </div>
      </div>
    </div>
  );
};

export default StatusChangeModal; 